import { registerController } from "../registry";

registerController("modal", (el: HTMLElement) => {
  el.querySelectorAll<HTMLElement>("[data-modal-open]").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const dialogId = trigger.dataset.modalOpen;
      if (!dialogId) return;
      const dialog = document.getElementById(dialogId) as HTMLDialogElement | null;
      if (dialog && typeof dialog.showModal === "function") {
        dialog.showModal();
      }
    });
  });

  el.querySelectorAll<HTMLElement>("[data-modal-close]").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const dialog = trigger.closest("dialog") as HTMLDialogElement | null;
      if (dialog) {
        dialog.close();
      }
    });
  });

  el.querySelectorAll<HTMLDialogElement>("dialog").forEach((dialog) => {
    dialog.addEventListener("click", (e: MouseEvent) => {
      if (e.target === dialog) {
        dialog.close();
      }
    });
  });
});
